import script from "./FileThumbnail.vue?vue&type=script&setup=true&lang=js"
export * from "./FileThumbnail.vue?vue&type=script&setup=true&lang=js"

import "./FileThumbnail.vue?vue&type=style&index=0&id=c208fe74&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c208fe74"]])

export default __exports__